import { render } from "./FullUsername.vue?vue&type=template&id=263e7187&scoped=true"
import script from "./FullUsername.vue?vue&type=script&lang=js"
export * from "./FullUsername.vue?vue&type=script&lang=js"

import "./FullUsername.vue?vue&type=style&index=0&id=263e7187&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263e7187"]])

export default __exports__